x<h3-layer-view-settings [viewModeOptions]="viewModeOptions">
  <ng-content></ng-content>
</h3-layer-view-settings>
